import React from "react";
import { Building2, Lock } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Trade {
  id: string;
  name: string;
}

interface BusinessUnitMatcherProps {
  mappingId: string;
  businessUnitName: string;
  tradeId: string;
  trades: Trade[];
  onMappingChange: (
    mappingId: string,
    field: "businessUnitId" | "tradeId",
    value: string,
  ) => void;
  isLocked: boolean;
}

const BusinessUnitMatcher: React.FC<BusinessUnitMatcherProps> = ({
  mappingId,
  businessUnitName,
  tradeId,
  trades,
  onMappingChange,
  isLocked,
}) => {
  return (
    <tr>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <Building2 className="h-5 w-5 text-gray-400 dark:text-slate-500 mr-3" />
          <div className="text-sm font-medium text-gray-900 dark:text-slate-100">
            {businessUnitName}
          </div>
        </div>
      </td>
      <td className="px-6 py-4 whitespace-nowrap">
        <div className="flex items-center gap-2">
          {isLocked && (
            <span title="This business unit is locked and cannot be modified">
              <Lock className="h-4 w-4 text-gray-400 dark:text-slate-500" />
            </span>
          )}
          <Select
            disabled={isLocked}
            onValueChange={(value) =>
              onMappingChange(mappingId, "tradeId", value)
            }
            value={tradeId || undefined}
          >
            <SelectTrigger className="max-w-xs">
              <SelectValue placeholder="Choose trade..." />
            </SelectTrigger>
            <SelectContent>
              {trades.map((trade) => (
                <SelectItem key={trade.id} value={trade.id}>
                  {trade.name}
                </SelectItem>
              ))}
              <SelectItem value="do_not_import">Do not import</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </td>
    </tr>
  );
};

export default BusinessUnitMatcher;
